import { ConfigurationOverview } from '@/components/configuration/overview'
import { createFileRoute } from '@tanstack/react-router'
import { store } from '@/state/breadcrumb-store'

export const Route = createFileRoute(
    '/customer/$customerId/configuration/$configurationId/',
)({
    component: RouteComponent,
})

function RouteComponent() {
    const { customerId, configurationId } = Route.useParams()
    store.trigger.changePath({
        newPath:
            [{ params: {}, to: "/customer", label: "Customer" },
            { params: { customerId: customerId }, to: "/customer/$customerId", label: customerId },
            { params: { customerId: customerId }, to: "/customer/$customerId", label: "Configuration" },
            { params: { configurationId, customerId }, to: "/customer/$customerId/configuration/$configurationId", label: configurationId },
            ]
    })
    return <ConfigurationOverview customerId={customerId} configurationId={configurationId}></ConfigurationOverview>
}
